import { LabelGroupsResponse } from '../../../shared/types';
import { useQueryClient } from '@tanstack/react-query';
import { Dispatch, SetStateAction, useEffect } from 'react';
import { GPanelContactsKeys } from '../../../gpanel-contacts-api';
import useDebounce from '../../../../../../utils/useDebounce';

function checkLabelNameCollision(
  labelName: string,
  labelGroups: LabelGroupsResponse['labelGroups']
): boolean {
  return labelGroups.some((labelGroup) =>
    labelGroup.labels.some((label) => label.name === labelName.trim())
  );
}

export const useCheckLabelNameCollision = (
  labelName: string,
  initLabelName: string,
  setErrorText: Dispatch<SetStateAction<string | null>>
) => {
  const queryClient = useQueryClient();
  const debouncedLabelName = useDebounce(labelName, 300);
  useEffect(() => {
    if (
      debouncedLabelName.trim() !== initLabelName &&
      checkLabelNameCollision(
        debouncedLabelName,
        queryClient.getQueryData<LabelGroupsResponse>([
          GPanelContactsKeys.LabelGroups,
        ])?.labelGroups ?? []
      )
    ) {
      setErrorText('Warning: Label name already exists');
    } else {
      setErrorText(null);
    }
  }, [debouncedLabelName, initLabelName]);
};
